/// <summary>
/// 请求相关
/// </summary>

import KitAPI from "../KitAPI";
import {KitBehaviour} from "../KitBehaviour";
import KitCfg from "../KitCfg";
import KitLog from "../KitLog";
import {AbCacher} from "./ABCacher";
import KitAB from "./KitAB";
import {KitEvent} from "../Track/KitEvent";
import {KitConst} from "../KitConst";
import {HttpConfig, HttpResponse} from "@/Fwk/Http/HttpConfig";
import {MD5Helper} from "@/Fwk/Encrypt/MD5Helper";
import {RSAHelper} from "@/Fwk/Encrypt/RSAHelper";
import {comRequest} from "@/Fwk/Http/comRequest";
import {ABEntity} from "@/Fwk/Kit/AB/ABEntity";
import {KitTrack} from "../Track/KitTrack";
import {KitAdjust} from "../Adjust/KitAdjust";
import {JObject} from "@/Fwk/Kit/JObject";
import {JsonData} from "@/Fwk/Kit/JsonData";
import {EventName} from "@/Fwk/Kit/Track/TrackConst";
import {ABConst} from "@/Fwk/Kit/AB/ABConst";
import Encrypt from "@/Fwk/Encrypt/Encrypt";
import AESHelper from "@/Fwk/Encrypt/AESHelper";

/// <author>xiexingwu</author>
export class ABRequest {
    // private static  HTTPNET = "";
    private static HTTPSNET = "";
    // private static  HTTPIP = "";

    private static mUrl = "";
    private static _lastRequestData: RequestData;
    private static _isRequesting = false;
    private static _delaysTimes = [3, 6];
    private static _startTime = 0;
    private static _delayIndex = 0;
    private static _delay = 0;
    private static _retryCount = 0;
    private static _needRequestBreakSilent = false;

    static Init() {
        // this.HTTPNET = ABConst.HTTP + KitCfg.nat_host + ABConst.ADDRESS;
        // this.HTTPSNET = ABConst.HTTPS + KitCfg.nat_host + ABConst.ADDRESS;
        // this.HTTPIP = ABConst.HTTP + ABConst.IP + ABConst.ADDRESS;
        this.HTTPSNET = ABConst.ADDRESS;
        this.mUrl = ABConst.HTTPS + KitCfg.nat_host;
    }

    static BreakSilent() {
        if (this._needRequestBreakSilent) this.Requst();
    }

    static Requst() {
        if (KitAB._isSilent) {
            this._needRequestBreakSilent = true;
            if (KitLog.IsLog) KitAB.Log("当前静默模式，不请求网络");
            return;
        }

        this._needRequestBreakSilent = false;

        if (!KitAPI.IsNetworkOk()) {
            if (KitLog.IsLog) KitAB.Log("网络异常，不执行请求逻辑");
            return;
        }

        const reqCount = AbCacher.GetRequestCount();
        if (reqCount >= ABConst.MAX_REQ_COUNT) {
            if (KitLog.IsLog) KitAB.Log(`当前请求次数已达最大:${reqCount} / ${ABConst.MAX_REQ_COUNT}，不执行请求逻辑`);
            return;
        }

        var data = new RequestData();

        if (this._isRequesting) {
            if (data.IsSame(this._lastRequestData)) {
                if (KitLog.IsLog) KitAB.Log("在请求中,参数没变");
                return;
            }

            if (KitLog.IsLog) KitAB.Log("在请求中,参数变化了，重新请求");
            data.CleanETag();//清除ETag
        }

        if (KitLog.IsLog) KitAB.Log("请求开始...");
        KitBehaviour._timer.clearTask("AbRequset");
        this._startTime = new Date().getTime();
        this.SendRequest(data);
    }


    static ForceRequst() {
        if (KitLog.IsLog) KitAB.Log("强制执行运营配置网络请求");
        this.ResetRetry();
        this.Requst();
    }

    public static async DoSendRequest<T>(config: HttpConfig): Promise<HttpResponse<T>> {
        this._isRequesting = true;
        const sendRequest = await comRequest<T>(config);
        this._isRequesting = false;
        return sendRequest;
    }

    private static async SendRequest(data: RequestData) {
        this._isRequesting = true;
        this._lastRequestData = data;
        const baseUrl = this.mUrl;
        const url = this.HTTPSNET;

        const body = data.BuildBodyData();
        if (KitLog.IsLog) {
            // KitAB.Log($"请求URL:动态域名:{entity}");
            // KitAB.Log("请求Head:[Content-Type:application/json]," +
            // $"[s-encode-v1:{(KitAPI.IS_WEB ? "s0523" : "s0514")}]," +
            // $"[s-encode-rsa:{data.rsaEncKey}]," +
            // $"[s-encode-sign:{data.sign}]," +
            // $"[s-encode-timestamp:{data.strStamp.ToString()}]," +
            // $"[sn-etag-hash:{data.eTag}]");

            KitAB.Log(`请求Data:${data.json?.toString() ?? ""}`);
            // KitAB.Log(`请求Body:${body}`,body);
            console.log(`请求Body:${body}`,body)
        }

        const config: HttpConfig = {
            baseUrl:baseUrl,
            url: url,
            method: 'POST',
            // encryptionType: 'noe',
            body:body,
            timeout: 15000,
            isToken: false,
            headers: {
                // 'Content-Type': 'application/json',
                // 's-encode-v1': 's0523',
                // 's-encode-rsa': data.rsaEncKey,
                // 's-encode-sign': data.sign,
                // 's-encode-timestamp': data.strStamp.toString(),
                'sn-etag-hash': data.eTag,
            },
        };

        KitEvent.track217(ABConst.AB_REQ_CONFIG)
            .Put(ABConst.APP_ID, KitCfg.releaseProductId)
            .Put(ABConst.SDK_VERSION_CODE, KitConst.KIT_VERSION_CODE)
            .Put(ABConst.SDK_VERSION_NAME, KitConst.KIT_VERSION_NAME)
            .Put(ABConst.REQ_ADDR, baseUrl)
            .Put(ABConst.api_version, KitAPI.IS_WEB ? ABConst.ADDRESS_VERSION_WEB : ABConst.ADDRESS_VERSION)
            .Put(ABConst.req_index, 0)
            .Put(ABConst.ETAG, data.eTag)
            .Commit();

        AbCacher.AddRequestCount();

        const response = await this.DoSendRequest<any>(config);
        // const responseData = response;
        if (this._lastRequestData != data) {
            if (KitLog.IsLog) KitAB.Log("Request->有新请求进行中，本次请求结果忽略");
            return
        }

        if (response.code == 200) {
            const text = JSON.stringify(response);

            if (KitLog.IsLog) KitAB.Log("Request->OK:" + baseUrl + ", text:" + text);
            this.OnSuccess(baseUrl, text);
        } else {
            if (KitLog.IsLog) KitAB.Log(`Request->Failed:${baseUrl}, code:未知, error:未知`);
            this.OnFail(`请求失败:原因:未知`, response.code+'', response.message, "", baseUrl);
        }

        if (KitLog.IsLog) KitAB.Log(`请求Http接口:${baseUrl}, 用时:${Math.round(new Date().getTime() - this._startTime)}s`);
    }

    private static getConsumeTime(): number {
        return Math.min(Math.round(new Date().getTime() - this._startTime) * 1000, 10 * 60 * 1000); //最大记录10分钟
    }

    private static ReSetUrl() {
        this.mUrl = this.HTTPSNET;
    }

    private static OnFail(msg: string, code: string, key: string, data: string, curURL: string) {
        if (KitLog.IsLog) KitAB.LogWarning(msg);

        switch (key) {
            case ABConst.BASE_NET_ERROR:
                KitEvent.track217(ABConst.AB_REQ_CONFIG_FAIL)
                    .Put(ABConst.APP_ID, KitCfg.releaseProductId)
                    .Put(ABConst.SDK_VERSION_CODE, KitConst.KIT_VERSION_CODE)
                    .Put(ABConst.SDK_VERSION_NAME, KitConst.KIT_VERSION_NAME)
                    .Put(ABConst.REQ_ADDR, curURL)
                    .Put(ABConst.REQ_INDEX, this.getRetryCount().toString())
                    .Put(ABConst.API_VERSION, KitAPI.IS_WEB ? ABConst.ADDRESS_VERSION_WEB : ABConst.ADDRESS_VERSION)
                    .Put(ABConst.ERROR_CODE, code)
                    .Put(ABConst.ERROR_MSG, msg)
                    .Put(ABConst.CONSUME_TIME, this.getConsumeTime().toString())
                    .Commit();

                if (!this.CanReTry()) {
                    this.ReSetUrl();
                    this.ResetRetry();
                    return;
                }

                // if (msg.toLowerCase().concat("SSL"))
                // {
                //     this._delay = 0;
                //     if (KitLog.IsLog) KitAB.Log("ssl握手超时，切换【http+原域名】马上重试");
                //     this.mUrl = ABRequest.HTTPNET;
                // }
                // else if (msg.ToLower().Contains("unknown"))
                // {
                //     _delay = 0;
                //     if (KitLog.IsLog) KitAB.Log("域名解析失败时，切换【http+ip】马上重试");
                //     mUrl = HTTPIP;
                // }
                // else
                // {
                //     _delay = _delaysTimes[_delayIndex % _delaysTimes.Length];
                //     if (KitLog.IsLog) KitAB.Log($"经过递增间隔时间 {_delay}s 后切换【https+原域名】重试");
                //     AddDelayIndex();
                //     mUrl = HTTPSNET;
                // }
                //
                // KitBehaviour.Instance._timer.SetTimer(_delay, () =>
                // {
                //     AddRetryCount();
                //     Requst();
                // }, "ABRequset");

                break;
            case ABConst.NO_CODE_SUC:
            case ABConst.NO_PARSE_SUC:
            case ABConst.PARSE_ERROR:
                KitEvent.track217(ABConst.AB_REQ_CONFIG_DATA_ERROR)
                    .Put(ABConst.APP_ID, KitCfg.releaseProductId)
                    .Put(ABConst.SDK_VERSION_CODE, KitConst.KIT_VERSION_CODE)
                    .Put(ABConst.SDK_VERSION_NAME, KitConst.KIT_VERSION_NAME)
                    .Put(ABConst.REQ_ADDR, curURL)
                    .Put(ABConst.REQ_INDEX, this.getRetryCount().toString())
                    .Put(ABConst.API_VERSION, KitAPI.IS_WEB ? ABConst.ADDRESS_VERSION_WEB : ABConst.ADDRESS_VERSION)
                    .Put(ABConst.ERROR_CODE, code)
                    .Put(ABConst.ERROR_MSG, msg)
                    .Put(ABConst.RESP_DATA, data)
                    .Put(ABConst.CONSUME_TIME, this.getConsumeTime().toString())
                    .Commit();
                break;
        }
    }

    private static OnSuccess(url: string, json: string) {
        if (KitLog.IsLog) KitAB.Log(`数据获取成功，下发解密前数据：${json}`);

        try {
            const data = new JsonData(null, json);
            const code = data.OptString(ABConst.CODE);
            if (code != ABConst.RES_CODE_OK) {
                this.OnFail(`结果码非200，${code} `, code, ABConst.NO_CODE_SUC, json, url);
                return;
            }

            const newEntity = AbCacher.ParseEntity(data);
            if (newEntity == null) {
                this.OnFail(`运营配置解析错误，${code} `, ABConst.FAILED_CODE, ABConst.NO_PARSE_SUC, json, url);
                return;
            }

            this.TakeNewEntity(newEntity, url);
        } catch (e) {
            this.OnFail(`运营配置解析异常，${e}`, ABConst.FAILED_CODE, ABConst.PARSE_ERROR, json, url);
        }
    }

    private static TakeNewEntity(newEntity: ABEntity, url: string) {
        const ollData = AbCacher.GetEntity().abExperimentData;
        KitAB.hadGotData = true;
        AbCacher.SetEntity(newEntity);

        if (this.CheckABDataChange(ollData, newEntity.abExperimentData)) {
            if (KitLog.IsLog) KitAB.Log("AB实验发生变化 appAliveAb");
            KitTrack.TrackALive(EventName.ALIVE_AB);
        }

        // ABAllowGameChecker.Check();
        KitAB.NotifyConfigSuc();

        KitEvent.track217(ABConst.AB_REQ_CONFIG_SUC)
            .Put(ABConst.APP_ID, KitCfg.releaseProductId)
            .Put(ABConst.SDK_VERSION_CODE, KitConst.KIT_VERSION_CODE)
            .Put(ABConst.SDK_VERSION_NAME, KitConst.KIT_VERSION_NAME)
            .Put(ABConst.REQ_ADDR, url)
            .Put(ABConst.ETAG, newEntity.etag)
            .Put(ABConst.FROM_ETAG, newEntity.fromEtag)
            .Put(ABConst.api_version, KitAPI.IS_WEB ? ABConst.ADDRESS_VERSION_WEB : ABConst.ADDRESS_VERSION)
            .Put(ABConst.req_index, this.getRetryCount().toString())
            .Put(ABConst.ab_exp_id, newEntity.ab_id)
            .Put(ABConst.ab_group_id, newEntity.ab_group_id)
            .Put(ABConst.ABTEST, newEntity.ab_group_id)
            .Put(ABConst.CONFIG_RESULT, "") //暂不实
            .Put(ABConst.CONSUME_TIME, this.getConsumeTime().toString())
            .Commit();

        this.ReSetUrl();
    }

    private static CheckABDataChange(oldJson: JObject[] | null, newJson: JObject[] | null): boolean {
        if (oldJson == null && newJson == null) {
            if (KitLog.IsLog) KitAB.Log("检查ab实验变化 oldJson == null && newJson == null");
            return false;
        }

        if (oldJson == null || newJson == null) {
            if (KitLog.IsLog) KitAB.Log("检查ab实验变化：oldJson == null or newJson == null");
            return true;
        }

        if (oldJson.length != newJson.length) {
            if (KitLog.IsLog) KitAB.Log("检查ab实验变化：实验个数发生变化");
            return true;
        }

        if (oldJson == newJson) {
            if (KitLog.IsLog) KitAB.Log("检查ab实验变化：无变化");
            return false;
        }

        const setOf: string[] = [];
        const unitAbString: string[] = [];
        for (let jObject of oldJson) {
            let item = new JsonData(jObject);
            unitAbString.push(item.OptString(AbCacher.Constants.AB_ID));
            unitAbString.push(item.OptString(AbCacher.Constants.AB_NAME));
            unitAbString.push(item.OptString(AbCacher.Constants.AB_GROUP_ID));
            unitAbString.push(item.OptString(AbCacher.Constants.AB_GROUP_NAME));
            unitAbString.push(item.OptString(AbCacher.Constants.AB_TYPE));
            setOf.push(unitAbString.toString());
        }

        for (let jObject of newJson) {
            let item = new JsonData(jObject);
            unitAbString.push(item.OptString(AbCacher.Constants.AB_ID));
            unitAbString.push(item.OptString(AbCacher.Constants.AB_NAME));
            unitAbString.push(item.OptString(AbCacher.Constants.AB_GROUP_ID));
            unitAbString.push(item.OptString(AbCacher.Constants.AB_GROUP_NAME));
            unitAbString.push(item.OptString(AbCacher.Constants.AB_TYPE));

            if (!setOf.concat(unitAbString.toString())) {
                if (KitLog.IsLog) KitAB.Log(`检查ab实验变化：有变化 ${unitAbString}`);
                return true;
            }
        }

        if (KitLog.IsLog) KitAB.Log("检查ab实验变化：无变化");
        return false;
    }

    private static AddDelayIndex() {
        return this._delayIndex++;
    }

    private static AddRetryCount() {
        return this._retryCount++;
    }

    private static getRetryCount(): number {
        return this._retryCount
    }

    private static ResetRetry() {
        this._retryCount = 0;
        this._delayIndex = 0;
        this._delay = 0;
    }

    private static CanReTry(): boolean {
        const isMaxRequest = this._retryCount >= ABConst.MAX_REQ_COUNT;
        const isMaxRetry = this._retryCount >= ABConst.MAX_RETRY_COUNT;
        if (isMaxRetry || isMaxRequest) {
            if (KitLog.IsLog) {
                const sr = isMaxRequest
                    ? `请求次数${this._retryCount} / ${ABConst.MAX_REQ_COUNT}`
                    : `重试次数 ${this._retryCount} / ${ABConst.MAX_RETRY_COUNT}`;
                KitAB.Log(`当天运营配置${sr},已达到最大，不再重试`);
            }
            return false;
        }
        return true;
    }
}

/// <summary>
/// 请求参数
/// </summary>
export class RequestData {
    public rsaEncKey: string = "";
    public sign: string = "";
    public strStamp: number = 0;
    public md5: string = "";
    public json: JsonData | undefined;
    public aesData: string = "";
    public eTag = "";

    constructor() {
        const currentTime = KitAPI.GetNowMills();
        const entity = AbCacher.GetEntity();
        const ab_group_id = entity.ab_group_id ?? "";
        const ab_id = entity.ab_id ?? "";
        const distributor = KitAdjust.GetDistributor() ?? "";
        const secondDistributor = KitAdjust.GetSecondDistributor() ?? "";
        const ADID = KitAPI.ADID ?? "";
        const UUID = KitAPI.UUID ?? "";
        const actviteDay = KitAPI.GetActviteDay();
        this.eTag = entity.etag ?? "";
        this.json = new JsonData();
        this.json.put(ABConst.API_VERSION, KitAPI.IS_WEB ? ABConst.ADDRESS_VERSION_WEB : ABConst.ADDRESS_VERSION);
        this.json.put(ABConst.AB_EXPERIMENT_GROUP_ID, ab_group_id);
        this.json.put(ABConst.AB_EXPERIMENT_ID, ab_id);
        this.json.put(ABConst.APP_ID, KitCfg.releaseProductId.toString());
        this.json.put(ABConst.APP_VERSION, KitAPI.versionCode.toString());
        this.json.put(ABConst.BUNDLE, KitAPI.packageName);
        this.json.put(ABConst.CAMPAIGN, secondDistributor);
        this.json.put(ABConst.CHANNEL, distributor);
        this.json.put(ABConst.COUNTRY, KitAPI.country);
        this.json.put(ABConst.DEVICE_ID, ADID);
        this.json.put(ABConst.USER_ID, UUID);
        this.json.put(ABConst.SYS_USER_ID, KitAPI.userId);
        this.json.put(ABConst.INSTALL_DAYS, actviteDay.toString());
        this.json.put(ABConst.LANGUAGE, KitAPI.language);
        this.json.put(ABConst.NETWORK_TYPE, KitAPI.GetNetworkType());
        this.json.put(ABConst.OS_VERSION, KitAPI.osVersion);
        this.json.put(ABConst.OS_TYPE, KitAPI.osType);
        this.json.put(ABConst.DEVICE_TYPE, KitAPI.deviceType);
        this.json.put(ABConst.REQ_ID, MD5Helper.CreateMD5(this.json.toString()));
        this.json.put(ABConst.TARGET_APP_ID, KitCfg.productId.toString());
        this.json.put(ABConst.H5_HOST_NAME, KitAPI.WebHotName);
        this.json.put(ABConst.TIMESTAMP, currentTime);
        const cs = ab_group_id + ab_id + distributor + secondDistributor + ADID + UUID + actviteDay + KitAPI.userId;
        this.md5 = MD5Helper.CreateMD5(cs).toLowerCase();
        this.strStamp = currentTime; // 时间戳

        //动态生成16位的IV
        const iv = AESHelper.GenerateIV(16);
        // rsa加密 IV
        const rsaEncKey = RSAHelper.Encrypt(iv);
        if (rsaEncKey){
            this.rsaEncKey = rsaEncKey;
        }
        const aesData = AESHelper.EncryptWeb(this.json.toString(), iv); // 请求数据AES加密
        this.aesData = aesData;

        // 数据签名，按通讯协议
        const sign = MD5Helper.CreateMD5(`${Encrypt.SIGN_KEY}${aesData}${Encrypt.SIGN_KEY}${currentTime}${Encrypt.SIGN_KEY}"`).toLowerCase();
        this.sign = sign;


    }

    IsSame(other: RequestData): boolean {
        return other != null && this.md5.toLowerCase() === other.md5.toLowerCase();
    }


    CleanETag() {
        this.eTag = "";
    }

    public BuildBody(): string {
        const js = new JsonData();
        js.put("request_data", this.aesData);
        js.put("timestamp", this.strStamp);
        js.put("sign", this.sign);
        return js.toString();
    }

    public BuildBodyData(): { } {
        const js = new JsonData();
        const data = this.json?.jObject;
        if (data){
            return data;
            // js.put("requestData", data);
        }
        js.put("timestamp", this.strStamp);
        js.put("sign", this.sign);
        return js;
    }


}